import React, { useState } from 'react';

import { TourService } from '~/types/tours/costPrice';
import { Supplier } from '~/types/tours/supplier';

import ServiceFormDialog from './ServiceFormDialog';
import SupplierPickerDialog from './SupplierPickerDialog';

interface Props {
  tour: { id: string; name: string };
  onClose: () => void;
  onCreated: (service: TourService) => void;
}

/**
 * Links a tour to a supplier, in the two steps svc-tour requires: choose the
 * supplier, then create its service for the tour. Creating the service is what
 * attaches the tour - there is no separate link call - so the flow always ends
 * in the service form.
 */
export default function LinkSupplierService({ tour, onClose, onCreated }: Props) {
  const [supplier, setSupplier] = useState<Supplier | null>(null);

  if (!supplier) {
    return (
      <SupplierPickerDialog
        open
        title="Link a supplier"
        description="Cost prices belong to a supplier's service. Choose the supplier this tour is bought from, then create its service for the tour."
        onClose={onClose}
        onSelect={setSupplier}
      />
    );
  }

  return <ServiceFormDialog open supplierId={supplier.id} tour={tour} onClose={onClose} onCreated={onCreated} />;
}
